import { useRouter } from "next/router";
import React         from "react";

import { isPageRoute } from "_common/utils";

import Presentation from "./presentation";

const component = props => {

	const router = useRouter ();

	const checkPageRoute = page => {
		return isPageRoute ( { router, page } );
	};

	return (
		<Presentation
			{ ...props }
			checkPageRoute = { checkPageRoute }
		/>
	);
};

export default component;
